// localStorage.setItem('preCart', JSON.stringify(LocalStoragePreCart));

	window.addEventListener('DOMContentLoaded', function() {    
		$(document).ready(function() {
			wishlistCartPage();
		});    
	})
	function wishlistCartPage() {

		$(".buttons__collection-wishlist-logged-in").on( "click", function(e) {
			 if ($(this).hasClass('swym-added')) {
			 	console.log('remove');
	          $(this).toggleClass('buttons__link--wishlist-remove');
	        }
	    });

			$( ".buttons__collection-wishlist-not-login" ).on( "click", function(e) {

				let productTitle = $(this).attr("data-title");
        		localStorage.setItem('swym-login-analitics', productTitle);


        	let variantID = $(this).attr("data-variant-id");
					let variantTitle = $(this).attr("data-variant-title");					
					let variantPrice = $(this).attr('data-variant-price');

					let productID = $(this).attr('data-product-id');
					
					let pageUrl = $(this).attr('data-product-url');

					/*console.log('variantID =' + variantID);
					console.log('variantTitle =' + variantTitle);
					console.log('variantPrice =' + variantPrice);
					console.log('productID =' + productID);
					console.log('pageUrl =' + pageUrl);*/

					let wishlistApiData = {
							"epi": variantID,
							"dt": productTitle,
							"du": pageUrl,
							"empi": productID,
							//"iu" : imageUrl,
							"pr": variantPrice,
							"variants": [{[variantTitle]: variantID}]
						}
			
				

				
        
        // add wishlist object for addToWishList() function to the localStorage
        function pushItemToLocalStorage(wishlistApiData) {
		      localStorage.setItem('swym-login-wishlist', JSON.stringify(wishlistApiData));          
        }

        pushItemToLocalStorage(wishlistApiData);

        var block = $(this).parents(".cart_product-info");
	       var quantity = block.find('input').val();
	        quantity = +quantity - 1;
	        var input = block.find('input');
	        input.val(quantity);
	        var eevent = new Event('change', { bubbles: true, cancelable: true })
	        input.get(0).dispatchEvent(eevent);

        setTimeout(() => {
            let localStorageWishlist = JSON.parse(localStorage.getItem('swym-login-wishlist')) || {};
            if (jQuery.isEmptyObject(localStorageWishlist) == false) {
              window.location.replace("/account/login");              
            } else {              
              pushItemToLocalStorage(wishlistApiData);
            }
        }, 500, wishlistApiData)
		
			});

		
			$(".wishlist__add").on( "click", function() {
	         var block = $(this).parents(".cart_product-info");
	         var quantity = block.find('input').val();
	          quantity = +quantity - 1;
	          var input = block.find('input');
	          input.val(quantity);
	          var eevent = new Event('change', { bubbles: true, cancelable: true })
	          input.get(0).dispatchEvent(eevent);
	    });
		
}
wishlistCartPage();

 document.addEventListener("swym:cartpage-loaded", function(event) {
    wishlistCartPage();
	});